import React from 'react'
import styled from 'styled-components'

import { Icon, IconType } from '../Icon'

const SlideOutPanelHeaderContainer = styled.div`
  height: var(--slideout-dialog-header-height, 5rem);
  background-color: var(--surface-primary);
  color: var(--text-primary);
  display: flex;
  align-items: center;
  position: relative;
  border-bottom: 1px solid var(--border);
`

const SlideOutPanelSticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
`

const CloseButton = styled.div`
  color: var(--text-primary);
  padding-left: 20px;
  transition: color 0.3s ease-out;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: var(--text-secondary);
  }
`

const FlexedContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  padding-right: 30px;
  color: var(--text-secondary);
`

const Actions = styled.div`
  display: flex;
  align-items: center;
`

const LeftContent = styled(Actions)`
  padding-left: 30px;
`

const CenterContent = styled(Actions)`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  color: var(--text-primary);
`

export type SlideOutPanelHeaderProps = {
  actions?: React.ReactNode
  leftContent?: React.ReactNode
  centerContent?: React.ReactNode
  onClose?: () => void
  children?: React.ReactNode
  closeIcon?: IconType
}

const SlideOutPanelHeader = ({
  actions,
  leftContent,
  centerContent,
  onClose,
  children,
  closeIcon,
}: SlideOutPanelHeaderProps) => {
  return (
    <SlideOutPanelSticky>
      <SlideOutPanelHeaderContainer>
        {onClose ? (
          <CloseButton onClick={onClose}>
            <Icon type={closeIcon ?? 'CLOSE_X'} height={36} width={36} />
          </CloseButton>
        ) : null}
        <CenterContent>{centerContent}</CenterContent>
        <FlexedContent>
          <LeftContent>{leftContent}</LeftContent>
          <Actions>{actions}</Actions>
        </FlexedContent>
      </SlideOutPanelHeaderContainer>
      {children}
    </SlideOutPanelSticky>
  )
}

export default SlideOutPanelHeader
